import { projectDataSourceSeed } from "@/lib/project-data-converters/client-cache";
import type { ProjectDataSourceDescriptor } from "@/types/aicheck";

export function isExternalProjectDataSource(
  source: ProjectDataSourceDescriptor | null | undefined,
): source is ProjectDataSourceDescriptor {
  return Boolean(source && source.kind !== "crm-api");
}

export function isSameProjectDataSource(
  left: ProjectDataSourceDescriptor | null | undefined,
  right: ProjectDataSourceDescriptor | null | undefined,
): boolean {
  if (!left || !right) return false;
  const leftCacheKey = left.origin?.cacheKey;
  const rightCacheKey = right.origin?.cacheKey;
  if (leftCacheKey && rightCacheKey && leftCacheKey === rightCacheKey) {
    return true;
  }
  const leftSeed = projectDataSourceSeed(left);
  const rightSeed = projectDataSourceSeed(right);
  if (leftSeed && rightSeed && leftSeed === rightSeed) {
    return true;
  }
  return (
    left.sourceId === right.sourceId ||
    (!!left.dataDigest && left.dataDigest === right.dataDigest)
  );
}
